module.exports = __webpack_public_path__ + "static/EnmTX_BosSnake_L_B_cl-5cde802b89bb2ce09aec47543977b2be.gif";